import React, { useState } from 'react';

const Tooltip = ({ children, text, position = 'top' }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="tooltip-container" onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>
      {visible && <div className={`tooltip-box ${position}`}>{text}</div>}
      {children}
    </div>
  );
};

export default Tooltip;
